<template>
	<div class="col-md-10 col-md-offset-1 m-b-25" v-show="canShowMap" v-bind:id="type" style="height: 180px"></div>
</template>

<script>
	export default {
		props: ['lat', 'lng', 'address', 'type'],
	 	computed: {
	        canShowMap: function () {
	            if(($.trim(this.lat) != '') && ($.trim(this.lng) != ''))
	            {
	                return true
	            }
	            return false
	        }
	    },
	    methods: {
	        showMap()
	        {
	            let vm = this
	            if(vm.canShowMap)
	            {
	                let centerLatLng = {lat: parseFloat(vm.lat), lng: parseFloat(vm.lng)}
	                let map = new google.maps.Map($('#'+vm.type)[0], {
	                    zoom: 12,
	                    center: centerLatLng
	                })
	                let marker = new google.maps.Marker({
	                    position: centerLatLng,
	                    map: map
	                });

	                google.maps.event.addListener(map, 'idle', function() {
	                    map.setCenter(centerLatLng)
	                    google.maps.event.trigger(map, 'resize')
	                })
	            }
	        }
	    },
	    watch: {
	        lat: function(lat) {
	            this.showMap()
	        }
	    },
	    mounted: function() {
	        this.showMap()
	    }
	}
</script>